import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Form, Col, Row, Button } from 'react-bootstrap';

export const ResetPasswordForm = () => {
  const [searchParams] = useSearchParams();
  const [validated, setValidated] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);

  const token = searchParams.get('token');
  const api = process.env.REACT_APP_IDP_PROVIDER;
  const resetPasswordEndpoint = `${api}/account/resetpassword`;

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const formData = new FormData(form);
    const password = formData.get('password');
    const confirmPassword = formData.get('confirmpassword');

    // Check if passwords match
    const passwordsMatch = password === confirmPassword;
    setConfirmPasswordInvalid(!passwordsMatch);

    if (form.checkValidity() && passwordsMatch) {
      setProcessing(true);
      setValidated(true);
      if (await resetPassword(password, token)) {
        setShowSuccess(true);
        setShowError(false);
      } else {
        setShowError(true);
      }
      setProcessing(false);
    } else {
      setValidated(true);
    }
  };

  const resetPassword = async (password, resetToken) => {
    try {
      const response = await fetch(resetPasswordEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password, resetToken }),
      });

      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      console.error("Error during password reset:", error);
      setShowError(true);
    }
    return false;
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Row>
        <Col md="12" className="mb-2">
          <Form.Control
            className="py-2"
            name="password"
            type="password"
            placeholder="New password"
            autoFocus
            required
            maxLength="25"
          />
          <Form.Control.Feedback type="invalid">Password is required and cannot be more than 25 characters</Form.Control.Feedback>
        </Col>
      </Row>
      <Row>
        <Col md="12" className="mb-2">
          <Form.Control
            name="confirmpassword"
            type="password"
            placeholder="New password (again)"
            required
            isInvalid={confirmPasswordInvalid}
          />
          <Form.Control.Feedback type="invalid">Passwords must match</Form.Control.Feedback>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Button variant="reset" type="submit" disabled={processing}>Reset Password</Button>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          {showSuccess &&
            <div className="reset-success">
              <span>Your password has been successfully changed!</span>
            </div>}
          {showError &&
            <div className="reset-error">
              <span>Your password could not be updated. Please ensure the link is not expired or <a href="/reset-password" className="link-info">try again</a></span>
            </div>}
        </Col>
      </Row>
    </Form>
  );
};